import { type ComponentType, type LazyExoticComponent, Suspense } from 'react';

import { Loader } from '@components';

export const Suspendable =
  <T extends object>(
    Component: ComponentType<T> | LazyExoticComponent<ComponentType<T>>
  ) =>
  (properties: T) => (
    <Suspense fallback={<Loader />}>
      <Component {...properties} />
    </Suspense>
  );
